// Generate code from clean architecture template

import { CityEntity } from '../entities';
import { CityPayloadForm } from '../ports/payloads';
import { CityRepository } from '../ports/repositories';

export class CreateCityUsecase {
  constructor(private readonly repo: CityRepository) {}

  async run(payload: CityPayloadForm): Promise<CityEntity> {
    const data = this.repo.createCity(payload);
    return data;
  }
}
